export default {
  ADD: 'Add',
  CANCEL: 'Cancel',
  CLEAR_FILTERS: 'Clear Filters',
  CONFIRM: 'Confirm',
  SAVE: 'Save',
  REMOVE: 'Remove',
  DEACTIVATE: 'Deactivate',
  RESEND: 'Resend',
  SEND_INVITE: 'Send Invite',
  GOT_IT: 'Got it',
  EDIT: 'Edit',
  DELETE: 'Delete',
  MOVE: 'Move',
  ADD_ADDRESS: 'Add Address',
  ADD_BIRTHDAY: 'Add Birthdate',
  ADD_JOB_TITLE: 'Add Job Title',
  ADD_EMAIL: 'Add Email',
  ADD_PHONE: 'Add Phone',
  ADD_WEBSITE: 'Add Website',
  SORT: 'Sort',
  ADD_DONOR: 'Add Donor',
  ADD_CONSTITUENT: 'Add Constituent',
  ADD_CONTRIBUTION: 'Add Contribution',
  ADD_INTERACTION: 'Add Interaction',
  ADD_OPPORTUNITY: 'Add Opportunity',
  ADD_TASK: 'Add Task',
  MULTI_ACTION_CLOSE: 'Close',
  BUTTON_FILTER: 'Filter',
  CREATE: 'Create',
  DISABLE: 'Disable',
  PUBLISH: 'Publish',
  SEND_EMAIL: 'Send Email',
  COPY_ADDRESS: 'Copy Address',
  CALL: 'Call',
  COPY_NUMBER: 'Copy Number',
  SELECT: 'Select',
  UPDATE: 'Update',
  VIEW: 'View',
  DRAG_AND_DROP_CTA:
    '<span1>Drag and drop files here</span1> <span2>or</span2> <button>Upload File</button>',
  REMOVE_FILE: 'Remove file',
  DISMISS: 'Dismiss',
  ADD_FILES: 'Add Files',
  HIDE_UPLOAD: 'Hide Upload',
  CLEAR_ALL: 'Clear All',
};
